import { render, staticRenderFns } from "./NewDashbord.vue?vue&type=template&id=6d9bde72&scoped=true"
import script from "./NewDashbord.vue?vue&type=script&lang=js"
export * from "./NewDashbord.vue?vue&type=script&lang=js"
import style0 from "./NewDashbord.vue?vue&type=style&index=0&id=6d9bde72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9bde72",
  null
  
)

export default component.exports